import * as React from "react";

export default function NotificationContentParagraph({ children }: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className="m-0 overflow-hidden text-ellipsis text-sm font-medium tracking-wide text-gray-500 dark:text-slate-400">
      {children}
    </p>
  );
}
